export const send_getPotentialDupes = async(campID:string,camp_name:string,camp_lat:string,camp_lon:string) => {
    let response:string;
    let success:boolean = false;
    let errMsg:string;

    await $.ajax({
        type: "post",
        url: "/getPotentialDupes",
        data: JSON.stringify({
            campID:campID,
            camp_name:camp_name,
            lat:camp_lat,
            lon:camp_lon
        }),
        contentType:"application/json",
        dataType:"html",
        success: (data) => {response=data;success=true;},
        error:(xhr,errStr,exc) => {errMsg = errStr}
    });

    return new Promise<string>((resolve,reject) => {
        if (success) resolve(response);
        else reject (Error(errMsg))
    });
};

export const send_reportDupeCamps = async(correct_campID:string,dupe_campID:string,reportByName:boolean) => {
    let response:string;
    let success:boolean = false;
    let errMsg:string;
    let data:string;

    //Users can select a potential dupe we provide, or (if there are none) enter the name of the dupe themselves
    if (reportByName) {
        data = JSON.stringify({
            correct_campID:correct_campID,
            dupe_name:dupe_campID
        });
    } else {
        data = JSON.stringify({
            correct_campID:correct_campID,
            dupe_campID:dupe_campID
        });
    };

    await $.ajax({
        type: "post",
        url: "/reportDupeCamp",
        data: data,
        contentType:"application/json",
        dataType:"html",
        success: (data) => {response=data;success=true;},
        error:(xhr,errStr,exc) => {errMsg = errStr}
    });

    return new Promise<string>((resolve,reject) => {
        if (success) resolve(response);
        else reject (Error(errMsg));
    });
};

export const send_reportPermClosed = async(campID:string) => {
    let response:string;
    let success:boolean = false;
    let errMsg:string;

    await $.ajax({
        type: "post",
        url: "/reportPermClosed",
        data: JSON.stringify({campID:campID}),
        contentType:"application/json",
        dataType:"html",
        success: (data) => {response=data;success=true;},
        error:(xhr,errStr,exc) => {errMsg = errStr}
    });

    return new Promise<string>((resolve,reject) => {
        if (success) resolve(response);
        else reject (Error(errMsg))
    });
};

export const send_reportTempClosed = async(campID:string,reopenDate:string|undefined) => {
    let response:string;
    let success:boolean = false;
    let errMsg:string;
    let data:string;

    //Did the user "know" when the camp will reopen
    if (reopenDate) {
        data = JSON.stringify({
            campID:campID,
            reopenDate:reopenDate
        });
    } else {
        data = JSON.stringify({campID:campID});
    };

    await $.ajax({
        type: "post",
        url: "/reportTempClosed",
        data: data,
        contentType:"application/json",
        dataType:"html",
        success: (data) => {response=data;success=true;},
        error:(xhr,errStr,exc) => {errMsg = errStr}
    });

    return new Promise<string>((resolve,reject) => {
        if (success) resolve(response);
        else reject (Error(errMsg))
    });
};

export const send_reportNewLocation = async(newLocData:Record<string,string>) => {
    let response:string;
    let success:boolean = false;
    let errMsg:string;

    await $.ajax({
        type: "post",
        url: "/reportNewLocation",
        data: JSON.stringify(newLocData),
        contentType:"application/json",
        dataType:"html",
        success: (data) => {response=data;success=true;},
        error:(xhr,errStr,exc) => {errMsg = errStr}
    });

    return new Promise<string>((resolve,reject) => {
        if (success) resolve(response);
        else reject (Error(errMsg))
    });
};

export const send_reportNotCampground = async(campID:string) => {
    let response:string;
    let success:boolean = false;
    let errMsg:string;

    await $.ajax({
        type: "post",
        url: "/reportNotCampground",
        data: JSON.stringify({campID:campID}),
        contentType:"application/json",
        dataType:"html",
        success: (data) => {response=data;success=true;},
        error:(xhr,errStr,exc) => {errMsg = errStr}
    });

    return new Promise<string>((resolve,reject) => {
        if (success) resolve(response);
        else reject (Error(errMsg))
    });
};

export const send_reportBadData = async(newCampData:Record<string,string>,newFeatures:Record<string,string[]>,remFeatures:Record<string,string[]>) => {
    let response:string;
    let success:boolean = false;
    let errMsg:string;

    await $.ajax({
        type: "post",
        url: "/reportBadData",
        data: JSON.stringify({
            campData:newCampData,
            newFeatures:newFeatures,
            remFeatures:remFeatures
        }),
        contentType:"application/json",
        dataType:"html",
        success: (data) => {
            response=data;
            success=true;
            $("#campReportThanks").modal("show");
            // Listen for the modal to be hidden
            $("#campReportThanks").on("hidden.bs.modal", function () {
            // Refresh the page
            location.reload();
        });
        },
        error:(xhr,errStr,exc) => {errMsg = errStr}
    });

    return new Promise<string>((resolve,reject) => {
        if (success) resolve(response);
        else reject (Error(errMsg))
    });
};